import styled from "styled-components"

import SVGIcon from "components/presenters/common/SVGIcon"

export default function AddPostAddess({ openShippingAddressForm }) {
  return (
    <Block>
      <AddPostAddressBtn onClick={openShippingAddressForm}>
        <PlusIconBlock>
          <SVGIcon name="plusIcon" />
        </PlusIconBlock>
        <AddPostAdressBtnTxt>배송지 추가</AddPostAdressBtnTxt>
      </AddPostAddressBtn>
    </Block>
  )
}

const Block = styled.div`
  padding: calc(100vw * (19 / 375)) 0;
`

const AddPostAddressBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f7f7f7;
  padding: calc(100vw * (16 / 375)) 0;
  width: 100%;
  border-radius: calc(100vw * (5 / 375));
`

const PlusIconBlock = styled.div`
  width: calc(100vw * (8 / 375));
  height: calc(100vw * (8 / 375));
  margin-right: calc(100vw * (7 / 375));

  svg {
    color: #4e4e4e;
  }
`

const AddPostAdressBtnTxt = styled.span`
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (16 / 375));
`
